import { render, staticRenderFns } from "./Account_Categories.vue?vue&type=template&id=ade01db8&scoped=true&"
import script from "./Account_Categories.vue?vue&type=script&lang=js&"
export * from "./Account_Categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade01db8",
  null
  
)

export default component.exports